import React from "react";
import * as S from "../styles";
import DSButton from "../../../components/DSButton";
import { FooterProps } from "./types";

const Footer = ({
  step,
  goNext,
  goBack,
  isLoading,
  onClose,
  hasSelectedInstallmentOption,
}: FooterProps) => {
  return (
    <S.FooterContainer>
      {step > 0 && (
        <DSButton
          buttonType="secondary"
          isCancelType
          buttonText="Voltar"
          height={30}
          style={{
            padding: "0.4rem 1.5rem",
          }}
          onClick={goBack}
          disabled={isLoading}
          isDisabled={isLoading}
          dataTestId="botao_voltar_parcelamento_fatura"
        />
      )}
      <DSButton
        buttonType="secondary"
        isCancelType
        buttonText="Cancelar"
        height={30}
        style={{
          padding: "0.4rem 1.5rem",
        }}
        onClick={onClose}
        isLoading={isLoading}
        disabled={isLoading}
        isDisabled={isLoading}
        dataTestId="botao_cancelar_parcelamento_fatura"
      />
      <DSButton
        buttonType="secondary"
        buttonText={step === 0 ? "Avançar" : "Confirmar"}
        height={30}
        style={{
          padding: "0.4rem 1.5rem",
        }}
        onClick={goNext}
        disabled={isLoading || !hasSelectedInstallmentOption}
        isDisabled={isLoading || !hasSelectedInstallmentOption}
        isLoading={isLoading}
        dataTestId="botao_confirmar_parcelamento_fatura"
      />
    </S.FooterContainer>
  );
};

export default React.memo(Footer);
